<div fxLayout="column" fxFill *ngIf="is_ready">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="filter-container" *ngIf="!filterReady">
    <button mat-flat-button (click)="loadDataSource()" class="button-refresh" [ngClass]="{'flex-blink': flexTable && flexTable.showReloadLink}">
      <mat-icon>refresh</mat-icon>&nbsp;{{'public.refresh'| translate}}
    </button>
    <div fxFlex="auto"></div>
    <button mat-flat-button (click)="filterReady=true" class="button-enable-filter">
      <mat-icon>filter_alt</mat-icon>&nbsp;{{ 'public.filter'|translate }}
    </button>
  </div>
  <form [formGroup]="filterForm" class="filter-form">
    <ng-container *ngIf="!filterReady;else BlockFormFilter">
      <div fxLayout="column" align="center">
        <span *ngIf="filterForm.get('start_dt').value && filterForm.get('end_dt').value">
          {{filterForm.get('start_dt').value | timeFormatDateShort }} --&gt;
          {{filterForm.get('end_dt').value | timeFormatDateShort}}
        </span>
        <span *ngIf="filterForm.get('phone_number').value">
          <strong>{{ 'stats.filter.phone_number'|translate }}</strong>: {{filterForm.get('phone_number').value}}
        </span>
        <span *ngIf="filterForm.get('queue_ids').value && filterForm.get('queue_ids').value.length">
          <strong>{{ 'stats.filter.queue'|translate }}</strong>: {{
          rendererQueue(filterForm.get('queue_ids').value)|truncateArray }}
        </span>
      </div>
    </ng-container>

    <ng-template #BlockFormFilter>
      <div fxLayout="row" fxLayoutAlign="start center" class="filter-container">
        <div fxFlex="50" class="col-left">
          <mat-form-field class="full-width">
            <mat-label>{{ 'campaign.startDt' | translate }}</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="start_dt"
              placeholder="{{ 'campaign.startDt' | translate }}">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            
            <mat-error *ngIf="filterForm.get('start_dt').invalid && filterForm.get('start_dt').touched"
              [flexFormControlError]="filterForm.get('start_dt')"></mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="50" class="col-right">
          <mat-form-field class="full-width">
            <mat-label>{{ 'campaign.endDt' | translate }}</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="end_dt"
              [matDatepickerFilter]="minEndDateFilter" placeholder="{{ 'campaign.endDt' | translate }}">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            
            <mat-error *ngIf="filterForm.get('end_dt').invalid && filterForm.get('end_dt').touched"
              [flexFormControlError]="filterForm.get('end_dt')" [customMessages]="{
              'flexDatepickerMin': 'filter_form.datepicker.date_value_cannot_lesser_than_min_value'|translate: {min:
                filterForm.get('start_dt').value | timeFormatDateShort}
            }"></mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" class="filter-container">
        <div fxFlex="50" class="col-left">
          <mat-form-field class="full-width">
            <mat-label>{{ 'stats.filter.phone_number' | translate }}</mat-label>
            <input matInput="tel" formControlName="phone_number"
              placeholder="{{ 'stats.filter.phone_number' | translate}}">
            <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'phone_number', false)"
              [disabled]="!filterForm.get('phone_number').value">
              <mat-icon>close</mat-icon>
            </button>
            
            <mat-error [flexFormControlError]="filterForm.get('phone_number')"></mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="50" class="col-right">
          <mat-form-field class="full-width">
            <mat-label>{{ 'stats.filter.select_queue' | translate }}</mat-label>
            <flex-select-queue-input [limitedByRole]="true" [multiple]="true" [showCheckAll]="true" queueType="inbound"
              placeholder="{{ 'stats.filter.select_queue' | translate }}" formControlName="queue_ids">
            </flex-select-queue-input>
            <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'queue_ids', true)"
              [disabled]="!filterForm.get('queue_ids').value || !filterForm.get('queue_ids').value.length">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button type="submit" mat-raised-button color="accent" (click)="applyFilter()">
          {{ 'public.apply' | translate}}
        </button>
      </div>
    </ng-template>
  </form>

  <div *blockUI="'flex-grid-block'" fxFlex="grow">
    <flex-table #flexTable [noHeader]="true" fxFill fxFlex [dataSource]="dataSource" [tableConfig]="tableConfig"
      [columnTemplates]="{dest_name: tplCallInfo}">

      <ng-template #tplIcon let-item="row">
        <div fxFlexFill fxLayout="row" fxLayoutAlign="center center">
          <mat-icon *ngIf="!item.sound_id; else voicemailBlock">call_missed</mat-icon>
          <ng-template #voicemailBlock>
            <mat-icon [color]="item.is_read ? '': 'warn'">voicemail</mat-icon>
          </ng-template>
          <mat-icon class="button-status" *ngIf="item.status == 'recall_success' || item.status == 'client_recall'">
            check_circle
          </mat-icon>
        </div>
      </ng-template>

      <ng-template #tplCallInfo let-item="row">
        <div fxLayout="column" class="full-width">
          <div fxLayout="row">
            <div fxFlex="40px" class="is-missed">
              <ng-container *ngTemplateOutlet="tplIcon; context: {row: item}"></ng-container>
            </div>

            <div fxFlex fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="start start">
                <h3 fxFlex="initial" class="mb-0 is-missed"
                  [matTooltip]="(item.calling_number | displayPhoneNumber) + (item.client_name ? ' (' + item.client_name + ')' : '') + (item.missed_call_count > 1 ? ' (' + item.missed_call_count + ')' : '')">
                  {{ ((item.calling_number | displayPhoneNumber) + (item.client_name ? ' (' + item.client_name + ')' :
                  '')
                  +
                  (item.missed_call_count > 1 ? ' (' + item.missed_call_count + ')' : '')) | truncate }}
                </h3>
              </div>
              <p class="mat-text-muted mb-0 mt-0 text-md dest-name" [matTooltip]="item.dest_name">
                <span class="inline-icon">
                  <ng-container [ngSwitch]="item.dest_type">
                    <mat-icon *ngSwitchCase="2">notes</mat-icon>
                    <mat-icon *ngSwitchCase="3">swap_horiz</mat-icon>
                  </ng-container>
                  {{ item.dest_name|truncate }}
                </span>
              </p>
            </div>

            <div *ngIf="item.recall_request_status === 1" fxFlex="30px" fxLayoutAlign="start center"
              class="middle-item">
              <mat-icon>notification_important</mat-icon>
            </div>

            <div fxFlex="90px" fxLayoutAlign="end start">
              <ng-container *ngTemplateOutlet="tplStartDate; context: {row: item}"></ng-container>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="tplStatus; context: {row: item}"></ng-container>

        </div>
      </ng-template>

      <ng-template #tplStatus let-item="row">
        <div class="full-width" fxLayout="row" fxLayoutAlign="center center">
          <div fxFlex class="text-center">
            <button class="button-detail" type="button" mat-icon-button color="primary" (click)="makeCall(item)"
              [disabled]="!item.calling_number || item.calling_number === 'anonymous'"
              [matTooltip]="'call.actions.make_call'|translate">
              <mat-icon>phone</mat-icon>
            </button>
          </div>
          <div fxFlex class="text-center">
            <span class="voicemail-player">
              <span class="voicemail-unread-mask" *ngIf="item.sound_id && !item.is_read"></span>
              <fileentry-player-button [disabled]="!item.sound_id" [filePublicId]="item.sound_id" lang=""
                (onPlay)="updateListened(item)" [matTooltip]="'voicemail.action.play_message'|translate">
              </fileentry-player-button>
            </span>
          </div>
          <div fxFlex class="text-center">
            <button mat-icon-button color="primary" (click)="detailMissedCall(item)"
              [matTooltip]="'stats.missed_call.actions.detail_call_info'|translate">
              <mat-icon>info</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #tplStartDate let-item="row">
        <div class="mat-text-muted text-md full-width" fxLayout="column" fxlayoutalign="start start">
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon-row">date_range</mat-icon>
            <span>{{ item.start_dt|dateInbox:'dateOnly' }}</span>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon-row">access_time</mat-icon>
            <span>{{ item.start_dt | date : 'HH:mm:ss' }}</span>
          </div>
        </div>
      </ng-template>

    </flex-table>
  </div>
</div>
